import { render, staticRenderFns } from "./ArticleRendaExtraComMiglyPro.vue?vue&type=template&id=cc02e87c&scoped=true&"
import script from "./ArticleRendaExtraComMiglyPro.vue?vue&type=script&lang=js&"
export * from "./ArticleRendaExtraComMiglyPro.vue?vue&type=script&lang=js&"
import style0 from "./ArticleRendaExtraComMiglyPro.vue?vue&type=style&index=0&id=cc02e87c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc02e87c",
  null
  
)

export default component.exports